import { employeeApi } from '@atheneum/api'
import { extendObservable, toJS } from 'mobx'
import pickBy from 'lodash/pickBy'
import mapValues from 'lodash/mapValues'

class EmployeeSearchStore {
  constructor (staticData) {
    extendObservable(this, {
      loading: null,
      error: null,
      employeesCount: null,
      employees: [],
      selectedEmployee: null,
      staticData,
      query: this.getEmptyQuery()
    })
    this.statusOptions = ['active', 'inactive', 'all']
  }

  clearSearch = () => {
    this.query = this.getEmptyQuery()
    this.search()
  }

  getEmptyQuery = () => {
    return {
      page: 1,
      employeeStatus: 'active',
      q: '',
      permissions: null,
      employeePosition: null,
      office: null,
      limit: 10
    }
  }

  search = (page = 1) => {
    this.loading = true
    this.query.page = page
    const preparedQuery = {
      ...mapValues(toJS(this.query), val => val && (val.id || val.value || val))
    }

    return employeeApi
      .search(pickBy(preparedQuery))
      .then(data => {
        this.employees.replace(data.rows)
        this.employeesCount = data.count
        this.loading = false
      })
      .catch(err => {
        this.error = err
        this.loading = false
      })
  }

  changePage = this.search
}

export default EmployeeSearchStore
